import { DeaSubjectsListingDialogComponent } from '../components/dea-pack/dea-subjects-listing-dialog/dea-subjects-listing-dialog.component';
import { BaseComponentService } from './_app/base-component.service';
import { SubjectListingParameters } from '../constants/interfaces';
import { ApiResponse } from '../models/api/api-response.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API } from '../constants/api';

@Injectable({ providedIn: 'root' })
export class SubjectService {
  private _baseComponentService = inject(BaseComponentService);
  private _http: HttpClient = inject(HttpClient);

  getListing(p: SubjectListingParameters) {
    return this._http.get<ApiResponse<any>>(API.subjectListing(p), {
      withCredentials: true,
    });
  }

  openSubjectsDialog() {
    const dialogSize = '800px';
    return this._baseComponentService.dialog.open(
      DeaSubjectsListingDialogComponent,
      {
        autoFocus: false,
        restoreFocus: false,
        minWidth: dialogSize,
        maxWidth: dialogSize,
      }
    );
  }
}
